export default "__VITE_ASSET__cDmH84i___"